module.exports = __webpack_public_path__ + "img/9788992844000.43e5d18d.jpg";